@if (
selectedReminder &&
authService.isAuthorized([PermissionsEnum.Scheduler_view])
) {
<app-scheduler-details (close)="selectedReminder=undefined" [reminderId]="selectedReminder.id!">
</app-scheduler-details>
}
<div class="subpage-container">
  <div class="container g-0 m-0">
    <div class="col d-flex align-items-center justify-content-start g-0 m-0 ps-5 pt-2 pb-2">
      <app-search class="pe-2" placeholder="{{ 'SETTINGS_SEARCHBYNAME' | translate }}"
        (searchChange)="searchChange($event)">
      </app-search>
      <app-sort class="pe-2" (close)="onSortOption($event)"></app-sort>
    </div>
    <div class="row g-0 m-0 pt-3 gap-3 p-4 ps-5 pe-5">
      <div *ngFor="let row of reminderData; let i = index"
        class="row g-0 p-0 d-flex justify-content-between member-info p-3">
        <div class="col d-flex p-0 justify-content-start" (click)="handleRowClickReminder(row)">
          <div class="col ps-3 pe-3">
            <div>
              <span class="item-title">{{ row.name }}</span>
            </div>
            <div class="text bolded">
              <span>
                {{ row.type}}</span>

              <svg-icon alt="Dot Icon" src="assets/settings/dot.svg" class="pe-2 ps-2"></svg-icon>
              <span>{{'LASTTRIGER' | translate}}
                {{ row.lastExecutionTime| date: "dd MMM yyyy, h:mm a" }}</span>
            </div>
          </div>
        </div>
        <div class="col-auto p-0 subtitle d-flex justify-content-end align-items-center text">
          <span class="status" [ngClass]="{
            'active': row.isActive,
            'inactive': !row.isActive
          }">
            {{ row.isActive ? 'Active' : 'Inactive' }}
          </span>
          <svg-icon alt="More" class="more-icon ps-1" src="assets/settings/more-icon.svg"
            (click)="setActiveRow(i)"></svg-icon>
          <!-- Dropdown -->
          @if (
          authService.isAuthorized([
          PermissionsEnum.Scheduler_modify,
          ])
          ) {
          <div *ngIf="activeRow === i" class="positioning">
            <div class="overlay-light" (click)="setActiveRow(null)"></div>
            <div class="dropdown-button p-2">
              <div class="dropdown-button-menu p-0 m-0">
                <div class="dropdown-button-item d-flex justify-content-start align-items-center p-2"
                  (click)="editReminder(row.id!)">
                  <svg-icon alt="Edit" src="assets/device/edit.svg"></svg-icon>
                  <span class="ps-2 item-title">{{'EDIT_SCHEDULER' | translate}}</span>
                </div>
                @if (
                !(!row.isActive) &&
                authService.isAuthorized([
                PermissionsEnum.Scheduler_modify,
                ])
                ) {
                <div class="dropdown-button-item d-flex justify-content-start align-items-center p-2"
                  (click)="changeStatus(row.id!, false)">
                  <svg-icon alt="Deactivate" src="assets/settings/deactivate.svg"></svg-icon>
                  <span class="ps-2 item-title">{{
                    "DEACTIVATE" | translate
                    }}</span>
                </div>
                }
                @if (
                !row.isActive &&
                authService.isAuthorized([
                PermissionsEnum.Scheduler_modify,
                ])
                ) {
                <div class="dropdown-button-item d-flex justify-content-start align-items-center p-2"
                  (click)="changeStatus(row.id!, true)">
                  <svg-icon alt="Activate" class="pb-1" src="assets/settings/activate.svg"></svg-icon>
                  <span class="ps-2 item-title">{{
                    "ACTIVATE" | translate
                    }}</span>
                </div>
                }
                @if (
                authService.isAuthorized([
                PermissionsEnum.Scheduler_monitoring
                ])
                ) {
                <div class="dropdown-button-item d-flex justify-content-start align-items-center p-2"
                  (click)="showMonitoring(row.id!)">
                  <svg-icon alt="Monitoring" src="assets/settings/monitoring.svg"></svg-icon>
                  <span class="ps-2 item-title">{{"MONITORING" | translate}}</span>
                </div>
                }
                @if (
                authService.isAuthorized([
                PermissionsEnum.Scheduler_delete
                ])
                ) {
                <div class="dropdown-button-item d-flex justify-content-start align-items-center p-2"
                  (click)="isModalOpen = true; selectedRowId = row.id!">
                  <svg-icon alt="Trash Can" src="assets/settings/trash-can-red.svg"></svg-icon>
                  <span class="ps-2 item-title red">{{
                    "DELETE" | translate
                    }}</span>
                </div>
                }
              </div>
            </div>
          </div>
          }
        </div>
      </div>
    </div>
  </div>
  <div class="container-down">
    <app-pagination [lastPageSize]="lastPageSize" [numberOfDevices]="numberOfReminders" [pageSize]="pageSize"
      [currentPage]="currentPage" (pageChange)="pageChange($event)">
    </app-pagination>
  </div>
</div>

<app-confirm-dialog *ngIf="isModalOpen" titleKey="DELETE" question="REMINDER_DELETE"
  (confirm)="delete(selectedRowId!)" (cancel)="isModalOpen = false; activeRow = null"></app-confirm-dialog>
